import { computed } from '@vue/composition-api'
import CollectionModule from '@/store/stores/collectionModule/CollectionModule'
import useDynamoDB from '@/store/hook/useDynamoDB'
import CustomAttributeDataDocument from '@/store/stores/collectionModule/documents/customAttribute/CustomAttributeDataDocument'

/**
 * カスタム属性データ: HOMEアイコン情報を操作するための処理
 * @see テーブル設計 https://docs.google.com/spreadsheets/d/1IlMFcrOsJCwWSRz7QF3mckK0WWsvQbeGKPIUPbDVWfo/edit?gid=1208779623#gid=1208779623
 */
export default function useHomeIconData() {
  // Collection modules
  const homeIconDataCollectionModule = CollectionModule.createStore(CustomAttributeDataDocument)

  const { searchDateRangeData } = useDynamoDB()

  /**
   * カスタム属性データ: HOMEアイコン情報を取得する
   */
  const fetchHomeIconData = async () => {
    const result = await searchDateRangeData({
      tableName: 'custom-attribute-data',
      partitionKey: 'attributeType',
      partitionKeyValue: 'HomeIcon',
      sortKey: 'createdDate',
    })
    homeIconDataCollectionModule.data = result as Array<CustomAttributeDataDocument>
  }

  /**
   * カスタム属性データ: HOMEアイコン情報
   */
  const homeIcons = computed(() => homeIconDataCollectionModule.data)

  /**
   * カスタム属性データをクリアする
   */
  const clearHomeIconData = () => {
    homeIconDataCollectionModule.clearData()
  }

  return {
    fetchHomeIconData,
    homeIcons,
    clearHomeIconData,
  }
}
